import { render, staticRenderFns } from "./OidcCallback.vue?vue&type=template&id=79cdec20&"
import script from "./OidcCallback.vue?vue&type=script&lant=ts&lang=js&"
export * from "./OidcCallback.vue?vue&type=script&lant=ts&lang=js&"
import style0 from "./OidcCallback.vue?vue&type=style&index=0&id=79cdec20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports